import React from 'react'
import { alignmentClass, ButtonConfig } from './buttonFieldUtils'

interface Props {
  element: {
    alignment?: string
    buttons?: ButtonConfig[]
  }
  onButtonClick?: (buttonIndex: number) => void
  selectedButtonIndex?: number | null
}

const ButtonRowPreview: React.FC<Props> = ({
  element,
  onButtonClick,
  selectedButtonIndex = null
}) => {
  const buttons = element.buttons || []

  return (
    <div className={`d-flex flex-wrap gap-2 ${alignmentClass(element.alignment)}`}>
      {buttons.map((button, index) => (
        <button
          key={button.id || `row-btn-${index}`}
          type='button'
          className='btn btn-lg fw-bold'
          style={{
            color: button.btnTxtColor,
            backgroundColor: button.btnBgColor,
            border: 'none',
            boxShadow: selectedButtonIndex === index ? '0 0 0 3px rgba(13, 110, 253, 0.4)' : 'none'
          }}
          onClick={(event) => {
            if (onButtonClick) {
              event.stopPropagation()
              onButtonClick(index)
            }
          }}
        >
          {button.buttonAction === 'previous' && <i className='bi bi-arrow-left me-2' />}
          {button.text || 'Button'}
          {button.buttonAction === 'next' && <i className='bi bi-arrow-right ms-2' />}
        </button>
      ))}
    </div>
  )
}

export default ButtonRowPreview
